const processImageList = (reportData) => {
    const propertyImages = reportData?.images?.property || [];
    const floorPlanImages = reportData?.images?.floor_plan || [];
    var imageList = [];
    if (propertyImages.length > 0 || floorPlanImages.length > 0) {
        for (let i = 0; i < propertyImages.length; i++) {
            imageList.push(propertyImages[i]?.basePhotoUrl);
        }
        for (let i = 0; i < floorPlanImages.length; i++) {
            imageList.push(floorPlanImages[i]?.basePhotoUrl);
        }
    }
    return imageList;
};

const safeLoanCalculation = (panels, loanSummary, sharedPanelProps) => {
    let isSafe = (
        !isNaN(sharedPanelProps?.loan_term)
        && sharedPanelProps?.loan_term > 0
        && !isNaN(sharedPanelProps?.guarantor_count)
        && sharedPanelProps?.guarantor_count > 0
        && sharedPanelProps?.da_status
        && sharedPanelProps?.da_status !== '--'
    );

    for (const key in panels) {
        if (['loan_term', ""].includes(key)) continue;

        const security = panels[key];
        // console.log(security)
        isSafe = isSafe && (
            !isNaN(security.values?.market_value)
            && !isNaN(security.values?.lvr)
            && !isNaN(security.values?.loan_amount)
            && security.values?.market_value > 0
            //&& security?.lvr > 0
            //&& security?.loan_amount > 0
            && security.values?.tc_rank
            && security.values?.property_usage !== '--'
        )


    }
    isSafe = isSafe && (
        !isNaN(loanSummary?.totalEMV)
        && !isNaN(loanSummary?.totalLoanAmount)
        && !isNaN(loanSummary?.totalLVR)
        && loanSummary?.totalEMV > 0
        && loanSummary?.totalLoanAmount > 0
        && loanSummary?.totalLVR > 0
    );
    // console.log('loanSummary', loanSummary)
    return isSafe
}

const isSafeNumInput = (value) => {
    let isSafe = value.replaceAll(' ', '') === '' || /^[0-9]*$/.test(value?.replaceAll(' ', ''));
    return isSafe
}
const isSafeFloatInput = (value) => {
    let isSafe = value.replaceAll(' ', '') === '' || /^[.0-9]*$/.test(value?.replaceAll(' ', ''));
    return isSafe
}

const formatCurrencyString = (value) => {
    let result = '--';
    if (!isNaN(value)) {
        result = value.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    }
    return result;
}

const formatPercentString = (value) => {
    let result = '--';
    if (!isNaN(value)) {
        result = value.toLocaleString('en-AU', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 3 });
    }
    return result;
}

const generateTrackerSecurity = (panels) => {

    let addressArray = []
    let postcodeArray = []
    let propertyTypeArray = []
    let propertyUsageArray = []
    let emvArray = []
    let linksArray = []
    let lvrArray = []

    Object.entries(panels).forEach(([key, value]) => {
        const security = value;
        const address = security?.storage?.addressSelected ?? '';
        const postcode = security?.postcode ?? '';
        const postcodeCate = security?.storage?.reportData?.cate ?? '';
        const propertyType = security?.property_type ?? '';
        const propertyUsage = security?.property_usage ?? '';
        const emv = security?.market_value ?? '';
        let links = '';
        if (security?.storage?.reportData?.links) {
            links = Object.entries(security?.storage?.reportData?.links).map(([key, value]) => `<a href="${value}" target="_blank" rel="noopener noreferrer">${key.charAt(0).toUpperCase() + key.substring(1).toLowerCase()}</a>`).join('&nbsp;&nbsp;');
        }
        let lvr = security?.lvr ?? '';

        if (address && address?.length > 0) {
            addressArray.push(address);
            postcodeArray.push(`${postcode} - ${postcodeCate}`);
            propertyTypeArray.push(`${address} - ${propertyType}`);
            propertyUsageArray.push(`${address} - ${propertyUsage}`);
            emvArray.push(`${address} - ${formatCurrencyString(emv)}`);
            linksArray.push(`${address}:<br/>${links}<br/>`);
            lvrArray.push(`${address} - ${formatPercentString(lvr)}`);

        }
    });

    let section = `
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Security Address</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
            ${addressArray.map(address => (
        `<span style='font-family:"Calibri",sans-serif;color:black;'>${address}</span><br/>`
    ))
        }
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Postcode</span></p>
        </td>
        <td nowrap  colspan=3 
            style='width:143.85pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:right'>
            ${postcodeArray.map(postcode => (
            `<span style='font-family:"Calibri",sans-serif;color:black;'>${postcode}</span><br/>`
        ))
        }
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Type of security</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
            ${propertyTypeArray.map(propertyType => (
            `<span style='font-family:"Calibri",sans-serif;color:black;'>${propertyType}</span><br/>`
        ))
        }
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Usage of the security</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>O/O or I/V</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
            ${propertyUsageArray.map(propertyUsage => (
            `<span style='font-family:"Calibri",sans-serif;color:black;'>${propertyUsage}</span><br/>`
        ))
        }
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>EMV</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
            ${emvArray.map(emv => (
            `<span style='font-family:"Calibri",sans-serif;color:black;'>${emv}</span><br/>`
        ))
        }
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Online EMV suggestion</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Web link</span></p>
        </td>
        <td colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
                ${linksArray}
            </p>
        </td>
    </tr>
    `


    return section;
};


const generateTrackerEmail = (panels, sharedPanelProps, loanSummary, pricingData) => {
    document.getElementById('tracker').innerHTML = '';
    console.log("tracker")
    // console.log('loanSummary', loanSummary)
    const lvr = formatPercentString(loanSummary.totalLVR);
    const loanAmount = formatCurrencyString(loanSummary.totalLoanAmount);
    const loanTerm = sharedPanelProps.loan_term;

    const interestRate = formatPercentString(pricingData.interest_rate);
    const establishmentFee = formatPercentString(pricingData.establishment_fee);
    const upfrontFee = formatCurrencyString(pricingData.upfront_fee);
    const securitySection = generateTrackerSecurity(panels);
    const rank = new Set()

    let addressArray = [];
    let lvrArray = []
    Object.entries(panels).forEach(([key, value]) => {
        const address = value?.storage?.addressSelected ?? '';
        let l = value?.lvr ?? '';
        if (address) {
            addressArray.push(address);
            lvrArray.push(`${address} - ${formatPercentString(l)}`);
        }
        const tcRank = value?.tc_rank ?? '';
        if (tcRank) {
            rank.add(tcRank)
        }
    })



    let template = `<table id="email-table" border=0 cellspacing=0 cellpadding=0 style='max-width: 600px;border-collapse:collapse;'>
    <tr style='height:15.0pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p>
                <span style='font-family:"Calibri",sans-serif;color:black;'>Broker Name</span>
                
            </p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:15.0pt'>
        <td nowrap style='width:218.0pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p><b><span style='font-family:"Calibri",sans-serif;color:black;'>1. The Security</span></b></p>
        </td>
        <td nowrap style='width:83.85pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p style='text-align:right'>
                
            </p>
        </td>
        <td nowrap style='width:43.85pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p style='text-align:right'>
            </p>
        </td>
        <td nowrap style='width:83.85pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p style='text-align:right'>
            </p>
        </td>
    </tr>
    ${securitySection}
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Current debt amount</span></p>
        </td>
        <td nowrap
            style='width:83.85pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
        <td nowrap
            style='width:20.25pt;border:solid windowtext 1.0pt;border-left:none;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>Lender</span></p>
        </td>
        <td nowrap
            style='width:83.85pt;border:solid windowtext 1.0pt;border-left:none;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Current LVR</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;'>Is this their only property?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Lease details</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'></td>
        <td nowrap colspan=3 style='width:151.1pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'></td>
    </tr>
    <tr style='height:15.0pt'>
        <td nowrap style='width:218.0pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p><b><span style='font-family:"Calibri",sans-serif;color:black;'>2. The Deal</span></b></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border-bottom:solid windowtext 1.0pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'></td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Type of Application (select)</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Ranking Needed</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;border-bottom:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>${[...rank].join(' & ')}</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>LVR Needed</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;border-bottom:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
                ${lvrArray.map(l => `<span style='font-family:"Calibri",sans-serif;color:black;'>${l}</span><br/>`)}
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Detailed summary of the deal</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;border-bottom:none;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Detailed Exit Strategy</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'></td>
        <td nowrap colspan=3 style='width:151.1pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
        </td>
    </tr>
    <tr style='height:15.0pt'>
        <td nowrap style='width:218.0pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p><b><span style='font-family:"Calibri",sans-serif;color:black;'>3. The Borrower</span></b></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'></td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>How do they generate income?</span>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>What's their existing company/business?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Is their company currently trading?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Guarantor age(s)</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Is the guarantor a local resident?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:248.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span nowrap style='font-family:"Calibri",sans-serif;color:black;'>How is the Guarantor's credit score look like?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Do they have any default?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Are they solvent?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Are they in any arrears of the current loan?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>How strong is their A&amp;L? </span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Can we get a copy of their A&amp;L?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Is there any third party Guarantor?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'></td>
        <td nowrap colspan=3 style='width:151.1pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
        </td>
    </tr>
    <tr style='height:15.0pt'>
        <td nowrap style='width:218.0pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p><b><span style='font-family:"Calibri",sans-serif;color:black;'>4. The Loan</span></b></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'></td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Loan Term seeking</span></p>
        </td>
        <td nowrap colspan=2 style='width:183.85pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>${loanTerm}</span></p>
        </td>
        <td nowrap
            style='width:83.85pt;border:solid windowtext 1.0pt;border-left:none;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Months</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Loan amount</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
                <span style='font-family:"Calibri",sans-serif;color:black;'>${loanAmount}</span>
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>LVR</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
                <span style='font-family:"Calibri",sans-serif;color:black;'>${lvr}</span>
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>How soon do they need to settle?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>What's the payout figure of current lender?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Have they shopped the deal already?</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'></td>
        <td nowrap style='width:83.85pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'></td>
        <td nowrap style='width:42.25pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'></td>
        <td nowrap style='width:83.85pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'></td>
    </tr>
    <tr style='height:15.75pt'>
        <td nowrap style='width:218.0pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.75pt'>
            <p><b><span style='font-family:"Calibri",sans-serif;color:black;'>5. Proposed Pricing</span></b></p>
        </td>
        <td nowrap style='width:83.85pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.75pt'></td>
        <td nowrap style='width:42.25pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.75pt'></td>
        <td nowrap style='width:83.85pt;background:#D9D9D9;padding:.75pt 5.4pt .75pt 5.4pt;height:15.75pt'></td>
    </tr>
    <tr style='height:15.0pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Loan Term</span></p>
        </td>
        <td nowrap colspan=2 style='width:183.85pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>${loanTerm}</span></p>
        </td>
        <td nowrap
            style='width:83.85pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:15.0pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Months</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>LVR</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span
                    style='font-family:"Calibri",sans-serif;color:black;'>${lvr}</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Interest Rate</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'>
                <span style='font-family:"Calibri",sans-serif;color:black;'>${interestRate}</span>
            </p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Line Fee</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>0.10%</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Establishment Fee</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>${establishmentFee}</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Upfront Fee</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>${upfrontFee}</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Broker Comm</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>&emsp;</span></p>
        </td>
    </tr>
    <tr style='height:14.25pt'>
        <td nowrap style='width:218.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p><span style='font-family:"Calibri",sans-serif;color:black;'>Ranking</span></p>
        </td>
        <td nowrap colspan=3 style='width:151.1pt;border:solid windowtext 1.0pt;padding:.75pt 5.4pt .75pt 5.4pt;height:14.25pt'>
            <p style='text-align:center'><span style='font-family:"Calibri",sans-serif;color:black;'>${[...rank].join(' & ')}</span></p>
        </td>
    </tr>
    </table>`.replaceAll('<br>,', '<br>').replaceAll('<br/>,', '<br>')
    // 0. Insert tracker template
    document.getElementById('tracker').innerHTML = template;

    // 1. Copy table HTML to clipboard
    const table = document.getElementById('email-table');
    const range = document.createRange();
    range.selectNode(table);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');

    selection.removeAllRanges(); // cleanup

    //alert("Tracker copied to clipboard. It’s ready to paste into your email.");

    // 2. Open default mail app with prefilled recipient/subject
    //const recipient = "recipient@example.com";

    const subject = encodeURIComponent(`Scenario - ${addressArray.map(address => address).join(' & ')}`);
    //const body = encodeURIComponent("Hi,\n\nPlease paste the copied table here and fill in the missing fields.\n\nThanks!");
    window.location.href = `mailto:?subject=${subject}`;

}

function toCamelCase(str) {
    return str.replace(/_([a-z0-9])/g, (_, char) => char.toUpperCase());
}

function convertKeysToCamelCase(obj) {
    if (Array.isArray(obj)) return obj.map(convertKeysToCamelCase);
    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([k, v]) => [toCamelCase(k), convertKeysToCamelCase(v)])
        );
    }
    return obj;
}

export { processImageList, safeLoanCalculation, isSafeNumInput, isSafeFloatInput, generateTrackerEmail, convertKeysToCamelCase }